var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CentralProviderContext } from '../centralProviderContext/CentralProviderContext';
import { LEGAL_DOCUMENTS } from '../constants/legalDocuments';
import { API_GATEWAY } from '../helpers/api';
import { useGetAccessToken } from './useGetAccessToken';
import { useEnqueueSnackbar } from './useEnqueueSnackbar';
import { SALESFORCE_LINKS } from '../types/AppsExternal';
export function useLegalDocuments() {
    var _this = this;
    var _a = __read(useState(), 2), termsOfUsePdf = _a[0], setTermsOfUsePdf = _a[1];
    var _b = __read(useState(), 2), termsOfServicePdf = _b[0], setTermsOfServicePdf = _b[1];
    var _c = __read(useState(), 2), privacyPolicyPdf = _c[0], setPrivacyPolicyPdf = _c[1];
    var accessToken = useGetAccessToken();
    var snackbar = useEnqueueSnackbar();
    var t = useTranslation().t;
    var currentLanguage = useContext(CentralProviderContext).currentLanguage;
    var language = currentLanguage || 'en_US';
    useEffect(function () {
        // Cleaning documents when the language change to retrieve them again using the right language
        setTermsOfUsePdf(undefined);
        setTermsOfServicePdf(undefined);
        setPrivacyPolicyPdf(undefined);
    }, [language]);
    var fetchLegalPdf = function (legalLink) {
        var legalDoc = LEGAL_DOCUMENTS[legalLink];
        return new Promise(function (resolve, reject) {
            fetch("".concat(API_GATEWAY, "/central/legaldocuments?file=").concat(legalDoc.pdf_key, "&lang=").concat(language), {
                method: 'GET',
                headers: {
                    Authorization: "Bearer ".concat(accessToken),
                    Accept: 'application/pdf',
                },
            })
                .then(function (response) { return response.blob(); })
                .then(function (blob) {
                var pdfUrl = URL.createObjectURL(blob);
                resolve(pdfUrl);
            }).catch(function () {
                reject();
            });
        });
    };
    var getTermsFile = function (legalLink) { return __awaiter(_this, void 0, void 0, function () {
        var pdfUrl, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchLegalPdf(legalLink)];
                case 1:
                    pdfUrl = _a.sent();
                    // eslint-disable-next-line default-case
                    switch (legalLink) {
                        case 'termsOfUse': {
                            setTermsOfUsePdf(pdfUrl);
                            break;
                        }
                        case 'termsOfService': {
                            setTermsOfServicePdf(pdfUrl);
                            break;
                        }
                        case 'privacyPolicy': {
                            setPrivacyPolicyPdf(pdfUrl);
                            break;
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    snackbar.enqueueMessages(t('Error retrieving legal document, please try again or contact administrator'), 'error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getSalesForceTermsLink = function (legalLink) {
        switch (legalLink) {
            case 'termsOfUse': {
                return SALESFORCE_LINKS.TERMS_OF_USE;
            }
            case 'privacyPolicy': {
                return SALESFORCE_LINKS.PRIVACY_POLICY;
            }
            default:
                return SALESFORCE_LINKS.TERMS_OF_USE;
        }
    };
    return {
        termsOfUsePdf: termsOfUsePdf,
        termsOfServicePdf: termsOfServicePdf,
        privacyPolicyPdf: privacyPolicyPdf,
        fetchLegalPdf: fetchLegalPdf,
        getTermsFile: getTermsFile,
        getSalesForceTermsLink: getSalesForceTermsLink
    };
}
//# sourceMappingURL=useLegalDocuments.js.map